import apiInstance from "./axios";
import {
  caddy_search,
  get_all_caddies,
  search_tf_date,
  caddy_leave_setup,
  caddy_booking,
} from "utils/services/api/schemas";

const caddyApi = {
  getCaddy: async (params) => {
    const response = await apiInstance.get(caddy_search, { params });
    return response;
  },
  getAllCaddies: async (params) => {
    const response = await apiInstance.get(get_all_caddies, { params });
    return response;
  },
  getCaddyById: async (caddyId) => {
    const response = await apiInstance.get(`${caddy_search}/${caddyId}`);
    return response;
  },

  searchTfDate: async (caddyId, params) => {
    const response = await apiInstance.get(`${search_tf_date}/${caddyId}`, {
      params,
    });
    return response;
  },
  createLeaveSetup: async (payload, isFormData) => {
    const response = await apiInstance.post(caddy_leave_setup, payload, {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      },
    });
    return response;
  },
  updateLeaveSetup: async (leaveId, payload, isFormData) => {
    const response = await apiInstance.put(
      `${caddy_leave_setup}/${leaveId}`,
      payload,
      {
        headers: {
          "Content-Type:": isFormData
            ? "multipart/form-data"
            : "application/json",
        },
      }
    );
    return response;
  },
  deleteLeaveSetup: async (leaveId) => {
    const response = await apiInstance.delete(
      `${caddy_leave_setup}/${leaveId}`
    );
    return response;
  },
  getLeaveSetup: async (params) => {
    const response = await apiInstance.get(caddy_leave_setup, { params });
    return response;
  },
  getCaddyBooking: async (caddyId) => {
    const response = await apiInstance.get(`${caddy_booking}/${caddyId}`);
    return response;
  },
};

export default caddyApi;
